import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TareaCasoService } from 'src/app/services/tareacaso.service';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';

@Component({
  selector: 'reclamos-medios-magneticos',
  templateUrl: './reclamos-medios-magneticos.component.html',
  styleUrls: ['./reclamos-medios-magneticos.component.scss'],
})
export class ReclamosMediosMagneticos implements OnInit {
  form: FormGroup;
  @Input() data: { task: any };
  analista: string;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    console.log('Task values', task);
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      nombre_cliente: [
        values ? values.nombre_cliente : '',
        [Validators.required],
      ],
      ci_rif_pasaporte: [
        values ? values.ci_rif_pasaporte : '',
        [Validators.required],
      ],
      numero_cuenta: [values ? values.numero_cuenta : ''],
      numero_sake: [values ? values.numero_sake : ''],
      fecha_inicio: [values ? values.fecha_inicio : '', [Validators.required]],
      fecha_fin: [values ? values.fecha_fin : '', [Validators.required]],
      total_monto_reclamado: [
        values ? values.total_monto_reclamado : '',
        [Validators.required],
      ],
      total_numero_tx_reclamadas: [
        values ? values.total_numero_tx_reclamadas : '',
        [Validators.required],
      ],
      medio_magenetico: [
        values ? values.medio_magenetico : '',
        [Validators.required],
      ],
      numero_medio: [values ? values.numero_medio : '', [Validators.required]],
      fecha_ultimo_uso: [
        values ? values.fecha_ultimo_uso : '',
        [Validators.required],
      ],
      fecha_bloqueo: [
        values ? values.fecha_bloqueo : '',
        [Validators.required],
      ],
      monto_reclamado_atm: [
        values ? values.monto_reclamado_atm : '0.00',
        [Validators.required],
      ],
      monto_reclamado_pos: [
        values ? values.monto_reclamado_pos : '0.00',
        [Validators.required],
      ],
      monto_reclamado_adelanto_taquilla: [
        values ? values.monto_reclamado_adelanto_taquilla : '0.00',
        [Validators.required],
      ],
      monto_reclamado_credcompra: [
        values ? values.monto_reclamado_credcompra : '0.00',
        [Validators.required],
      ],
      monto_reclamado_otras_operaciones: [
        values ? values.monto_reclamado_otras_operaciones : '0.00',
        [Validators.required],
      ],
      monto_reclamado_comisiones: [
        values ? values.monto_reclamado_comisiones : '0.00',
        [Validators.required],
      ],
      monto_salvado_atm: [
        values ? values.monto_salvado_atm : '0.00',
        [Validators.required],
      ],
      monto_salvado_pos: [
        values ? values.monto_salvado_pos : '0.00',
        [Validators.required],
      ],
      monto_salvado_adelanto_taquilla: [
        values ? values.monto_salvado_adelanto_taquilla : '0.00',
        [Validators.required],
      ],
      monto_salvado_credcompra: [
        values ? values.monto_salvado_credcompra : '0.00',
        [Validators.required],
      ],
      monto_salvado_otras_operaciones: [
        values ? values.monto_salvado_otras_operaciones : '0.00',
        [Validators.required],
      ],
      monto_salvado_comisiones: [
        values ? values.monto_salvado_comisiones : '0.00',
        [Validators.required],
      ],
      monto_sujeto_desicion_atm: [
        values ? values.monto_sujeto_desicion_atm : '0.00',
        [Validators.required],
      ],
      monto_sujeto_desicion_pos: [
        values ? values.monto_sujeto_desicion_pos : '0.00',
        [Validators.required],
      ],
      monto_sujeto_desicion_adelanto_taquilla: [
        values ? values.monto_sujeto_desicion_adelanto_taquilla : '0.00',
        [Validators.required],
      ],
      monto_sujeto_desicion_credcompra: [
        values ? values.monto_sujeto_desicion_credcompra : '0.00',
        [Validators.required],
      ],
      monto_sujeto_desicion_otras_operaciones: [
        values ? values.monto_sujeto_desicion_otras_operaciones : '0.00',
        [Validators.required],
      ],
      monto_sujeto_desicion_comisiones: [
        values ? values.monto_sujeto_desicion_comisiones : '0.00',
        [Validators.required],
      ],
      monto_numero_tx_atm: [
        values ? values.monto_numero_tx_atm : '0.00',
        [Validators.required],
      ],
      monto_numero_tx_pos: [
        values ? values.monto_numero_tx_pos : '0.00',
        [Validators.required],
      ],
      monto_numero_tx_adelanto_taquilla: [
        values ? values.monto_numero_tx_adelanto_taquilla : '0.00',
        [Validators.required],
      ],
      monto_numero_tx_credcompra: [
        values ? values.monto_numero_tx_credcompra : '0.00',
        [Validators.required],
      ],
      monto_numero_tx_otras_operaciones: [
        values ? values.monto_numero_tx_otras_operaciones : '0.00',
        [Validators.required],
      ],
      monto_numero_tx_comisiones: [
        values ? values.monto_numero_tx_comisiones : '0.00',
        [Validators.required],
      ],
      descripcion_hechos: [
        values ? values.descripcion_hechos : '',
        [Validators.required],
      ],
      alerta_monitoreo: [
        values ? values.alerta_monitoreo : '',
        [Validators.required],
      ],
      gestion_alerta: [
        values ? values.gestion_alerta : '',
        [Validators.required],
      ],
      notificacion_sms: [
        values ? values.notificacion_sms : '',
        [Validators.required],
      ],
    });
  }

  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
